<template>
  <el-dialog
    class="add-solidity-contract-dialog common-dialog"
    title="上传合约文件"
    :visible.sync="showDialog"
    :before-close="cacel"
    top="25vh"
    @open="handleOpen"
  >
    <el-alert
      class="alert-info"
      title="提示"
      type="info"
      description="请上传Solidity合约的源码文件或字节码文件"
      show-icon
      :closable="false"
    ></el-alert>
    <el-form ref="addSolidityContract" :model="model" :rules="rules" :label-width="`${adaptationVars.formLabelWidth}px`">
      <el-form-item label="文件类型" prop="type">
        <el-select v-model="model.type" placeholder="请选择文件类型">
          <el-option
            v-for="(item, index) in typeOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Solidity版本" prop="version">
        <el-select v-model="model.version" placeholder="请选择Solidity版本">
          <el-option
            v-for="(item, index) in versionOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合约文件" prop="fileRaw">
        <upload-files
          ref="contractFile"
          :file-ext="fileExt"
          @uploadSuccess="onUploadSuccess"
          @uploadFailed="onUploadFailed"
          @uploadRemove="onUploadRemove"
        ></upload-files>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cacel">取 消</el-button>
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'AddSolidityContract',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  props: {
    dialogVisible: Boolean
  },
  data() {
    return {
      model: {
        type: 'solidity',
        version: null,
        fileRaw: ''
      },
      rules: {
        type: [{ required: true, message: '请选择文件类型', trigger: 'blur' }],
        version: [{ required: true, message: '请选择Solidity版本', trigger: 'blur' }],
        fileRaw: [{ required: true, message: '请按要求上传合约文件', trigger: 'blur' }]
      },
      typeOptions: [
        {
          id: 'solidity',
          name: '源码文件'
        },
        {
          id: 'bytecode',
          name: '字节码文件'
        }
      ],
      versionOptions: [],
      showDialog: false,
      fileExt: '.sol|',
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    },
    model: {
      deep: true,
      immediate: true,
      handler(val, oldval) {
        if (val.type == 'bytecode') {
          this.fileExt = '.bin-runtime|'
        } else {
          this.fileExt = '.sol|'
        }
      }
    }
  },
  methods: {
    handleOpen() {
      this.getSolidityVersions()
    },
    cacel() {
      this.showDialog = false
      this.$refs.contractFile.clear()
    },
    makeSure() {
      let self = this
      this.$refs['addSolidityContract'].validate(valid => {
        if (valid) {
          console.log('submit!')
          let formData = new FormData()
          formData.append('type', self.model.type)
          formData.append('solc_version', self.model.version)
          formData.append('solidity_contract', self.model.fileRaw.raw)
          self.$apis.contractdetector.uploadSolidityContract(formData).then(res => {
            if (res && res.data && res.code === 1) {
              self.showDialog = false

              self.$emit('addSuccess')
              self.$message({
                type: 'success',
                message: '上传合约成功!'
              })
            } else {
              if (!res.error) {
                self.$message({
                  type: 'error',
                  message: '上传合约失败!'
                })
              } else {
                const h = self.$createElement
                self.$message({
                  type: 'error',
                  message: h('p', null, [
                    h('div', { style: 'color: red' }, '上传合约失败!'),
                    h('div', { style: 'color: teal' }, res.error)
                  ])
                })
              }
            }
            // console.log(res)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onUploadSuccess() {
      this.model.fileRaw = this.$refs.contractFile.getFileRaw()
      this.$refs.addSolidityContract.clearValidate()
    },
    onUploadFailed() {
      this.model.fileRaw = ''
    },
    onUploadRemove() {
      this.model.fileRaw = ''
    },
    getSolidityVersions() {
      let self = this
      this.$apis.contractdetector
        .getSolidityVersions()
        .then(data => {
          if (data && data.data && data.code == 1) {
            let versions = []
            for (let i = 0; i < data.data.length; i++) {
              versions.push({
                id: data.data[i],
                name: data.data[i]
              })
            }
            self.versionOptions = versions
          } else {
            console.log(e)
          }
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.add-solidity-contract-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .alert-info {
    margin-bottom: var(--base-size-20);
    width: 90%;
    margin-left: 5%;
  }

  .el-form {
    margin-right: var(--base-size-48);
  }
}
</style>
